import { useEffect } from 'react';
import './OurServices.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import about1 from '../assets/about1.jpg';
import service1 from '../assets/service6.jpg';
import service2 from '../assets/service7.jpg';
import service3 from '../assets/service8.jpg';
import service4 from '../assets/service4.png';
import service5 from '../assets/service5.png';
const OurServices = () => {
  

const services = [
  {
    id: 1,
    title: 'Commercial & Residential AC Installation',
    image: about1,   // just the variable, no {}
    side: 'left'
  },
  {
    id: 2,
    title: 'Authorized Brand Servicing (Samsung & Carrier)',
    image: service4,
    side: 'right'
  },
  {
    id: 3,
    title: 'AMC & Breakdown Maintenance',
    image: service3,
    side: 'left'
  },
  {
    id: 4,
    title: 'Duct Manufacturing & Supply',
    image: service2,
    side: 'right'
  },
  {
    id: 5,
    title: 'Support Services for Builders & Project Contractors',
    image: service5,
    side: 'left'
  },
  {
    id: 6,
    title: 'HVAC Duct Installation & Modification',
    image: service2,
    side: 'right'
  },
  {
    id: 7,
    title: 'Project Reporting & Client Updates',
    image: service1,
    side: 'left'
  }
];


 useEffect(() => {
  AOS.init({
    duration: 1200,
    easing: 'ease-out',
    once: false, // animate every time
    mirror: true, // animate out while scrolling past
  });

  // Refresh AOS after every render
  AOS.refresh();
}, []);

  return (
    <div className="our-services-section">
      <div className="services-overlay"></div>

      <div className="services-content">
        <h1 className="services-heading">Our Services</h1>

        <div className="services-container">
          <div className="center-line"></div>

          {services.map((service) => (
             <div
    key={service.id}
    className={`service-item ${service.side}`}
    data-aos={service.side === 'left' ? 'fade-right' : 'fade-left'}
    data-aos-once="false" // 100ms delay per item
  >
              <div className="service-card">
                <div className="service-image">
                  <img src={service.image} alt={service.title} />
                </div>
                <div className="service-text">
                  <h3>{service.title}</h3>
                  {service.description && <p>{service.description}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurServices;
